import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';

import { Report } from 'src/app/model/report';
import { ReportProvider } from 'src/app/providers';
import { ToasterService } from 'src/app/services';

@Component({
  selector: 'app-required-information',
  templateUrl: './required-information.component.html',
  styleUrls: ['./required-information.component.scss']
})
export class RequiredInformationComponent {

  constructor(private reportProvider: ReportProvider,
    private toastr: ToasterService,
    private router: Router) { }

  /**
   * @description user can skip introduction questions for next new reports
   * @param event selected option
   */
  skipIntroduction(event: boolean = false) {
    localStorage.setItem('VALZY_RPT_INTRO_SKIP', event.toString());
  }

  /**
   * @description for create new report
   */
  createReport() {
    this.toastr.info('Please wait a moment!');
    const report = new Report();
    this.reportProvider.createReport(report).subscribe(resp => {
      if (resp.success) {
        this.router.navigate(['/report', resp.result.ID]);
      } else {
        this.toastr.error(resp.error.txt);
        this.router.navigateByUrl('/dashboard');
      }
    });
  }

  @HostListener('window:keyup.space', ['$event'])
  onKeyUp($event: KeyboardEvent) {
    this.createReport();
  }

}
